import { Injectable } from '@angular/core';

const DEMO_FLAG = 'advocad-demo-mode';

/**
 * Whether the app is running as the public interactive demo: the real app
 * shell + pages, but the login guard lets the visitor straight in and the
 * demo API interceptor answers every request from an in-memory store.
 *
 * The flag lives in sessionStorage so a full page reload (Angular reboots)
 * stays in the demo, while closing the tab leaves it.
 */
@Injectable({ providedIn: 'root' })
export class DemoModeService {
  get active(): boolean {
    try {
      return sessionStorage.getItem(DEMO_FLAG) === '1';
    } catch {
      return false;
    }
  }

  enable(): void {
    try {
      sessionStorage.setItem(DEMO_FLAG, '1');
    } catch {
      // storage unavailable (rare) — demo simply won't survive a reload
    }
  }

  disable(): void {
    try {
      sessionStorage.removeItem(DEMO_FLAG);
    } catch {
      // nothing to clean up if storage is unavailable
    }
  }
}
